module.exports = __webpack_public_path__ + "img/person-sledding.bd0e40d6.svg";